module.exports = __webpack_public_path__ + "img/certified.37689007.svg";